var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4503861,32.0990678 L32.1454226,61.4040313 C29.1360476,64.3122561 22.4887695,66.1835938 17.904541,61.4040313 C13.3203125,56.6244689 15.6286062,51.1576276 17.904541,48.3122559 C18.0568749,47.6180868 39.9625916,25.8088649 39.9625916,25.8088649 C41.4756502,24.2958064 43.9413041,24.3083472 45.4699209,25.836964 C46.9984495,27.3654926 47.0109903,29.8311465 45.4979318,31.3442051 L23.581011,53.2611258 C21.3112487,55.5308882 24.1298315,58.349471 26.3995939,56.0797087 L56.7725553,25.7067473 C58.7169912,23.3331455 57.3345717,18.5242218 55.1223575,16.3120076 C52.8296527,14.0193028 47.7472261,12.6164587 45.4775511,14.8861337 C45.4775511,14.8861337 13.9721083,46.3915764 12.8129229,47.5507618 C11.6538248,48.70986 8.6235456,49.2621208 7.0949288,47.733504 C5.56631199,46.2048872 5.64837097,43.6448098 7.27767094,42.0155098 C29.1301671,20.1244581 40.1228367,9.13178851 40.2556797,9.0375011 C45.5736761,4.05469134 55.3577947,5.58898439 60.6015877,10.8327774 C64.9553994,15.1865891 69.017334,25.7067473 61.4503861,32.0990678 Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clip.15f8115a2843a21c1c537ae7054de769.svg";